import { ApiProvider } from "@src/store/ApiProvider";
import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { handlePasswordManagerUnauthorized } from "./passwordManagerUnauthorized";

// TAC-1450: backend returns this when previewing a TM-family password rotation.
// `affectedCredentials` is empty for non-TM-family credentials — UI should treat
// that as "no propagation, just save" rather than as an error.
export interface IPropagationPreviewItem {
	credentialId: number;
	vendorId: number;
	vendorName: string;
}

export interface ICredentialPropagationPreview {
	sourceCredentialId: number;
	email: string;
	sourceVendorName: string;
	affectedCredentials: Array<IPropagationPreviewItem>;
}

export interface IGetPropagationPreviewParams {
	credentialId: number;
}

const initialState: ICredentialPropagationPreview = {
	sourceCredentialId: 0,
	email: "",
	sourceVendorName: "",
	affectedCredentials: [],
};

const propagationPreviewPath = "/passwordManager/Credentials/propagation-preview";

const buildExternalUrl = (params: IGetPropagationPreviewParams) => {
	const baseUrl = ApiProvider.default.passwordManagerBaseURL || "https://qa.stagefront.com/password-manager/api";
	return `${baseUrl.replace(/\/$/, "")}/Credentials/${params.credentialId}/propagation-preview`;
};

const getAuthHeaders = () => {
	const token = localStorage.getItem("PasswordManager_accessToken") ?? "";
	return {
		Authorization: token ? `Bearer ${token}` : undefined,
		passwordManagerAccessToken: token || undefined,
	};
};

export const { thunk: getPropagationPreview, slice: propagationPreviewSlice } = getThunkAndSlice<
	IGetPropagationPreviewParams,
	ICredentialPropagationPreview
>({
	initialState,
	path: propagationPreviewPath,
	// Cache per credentialId; callers should pass `skipCache: true` for fresh data when
	// they're about to act on the result (e.g., right before showing the confirm dialog).
	cacheId: "credentialId",
	externalPath: buildExternalUrl,
	getHeaders: getAuthHeaders,
	onUnauthorized: handlePasswordManagerUnauthorized,
});
